import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'babel-polyfill';

import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { initSign } from '@beisen/fetch';

import App from './App';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

document.domain = 'italent.cn'
const BSGlobal = window.top.BSGlobal || {}
const tenantid = BSGlobal?.tenantInfo?.Id || ''
const userid = BSGlobal?.userInfo?.userId || ''

initSign({
  app: 'Recruitment',
  tenantid,
  userid,
}).then(() => {
  ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
      <App />
    </BrowserRouter>,
    rootElement);
});
